


























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class ComboBox<T> extends Vue {
  @Prop({ default: () => [] }) items?: T[];
  @Prop({ default: "" }) label?: string;
  @Prop({ default: "" }) placeholder?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) multiple?: boolean;
  @Prop({ default: "text" }) itemText?: string;
  @Prop({ default: () => [] }) value?: T[];
  @Prop() rules?: string;
  @Prop() name?: string;
  @Prop({ default: true }) clearable?: boolean;
  @Prop({ default: "" }) dataCy?: string;

  onValueUpdated(value: unknown[] | undefined) {
    this.fixErrorMessageFOUCIssue();
    this.$emit("input", value);
  }

  //The error message will flash (appear and disappear quickly) after correct item is selected
  //Below is the workaround the fix the issue
  fixErrorMessageFOUCIssue() {
    const errorMsg = this.$refs.errorMsg as Element;
    errorMsg.classList.add("comboBox-hidden-element");
    setTimeout(() => {
      errorMsg.classList.remove("comboBox-hidden-element");
    }, 100);
  }
}
